import Vue from 'vue'
import user from '@/api/modules/user'
import router from '@/router'
import { checkAdvisoryRole, checkStatisticsOnlyRole } from '@/utils/roles'

const getDefaultState = () => {
  return {
    isAdmin: false,
    profile: null
  }
}

const state = getDefaultState()

const actions = {
  fetchUser (context, cached = true) {
    if (cached && context.state.profile) {
      return Promise.resolve()
    } else {
      return user.fetch()
        .then((data) => {
          context.commit('saveUserData', data)
          return Promise.resolve()
        })
        .catch(async ({response}) => {
          if (response.status === 401) {
            context.commit('resetState')

            await router.push({ name: 'login' })
            return Promise.reject(response.status)
          }
        })
    }
  }
}

const mutations = {
  saveUserData (state, data) {
    Vue.set(state, 'profile', data)

    const adminStatus = data.roles.find(role => role === 'admin')
    state.isAdmin = Boolean(adminStatus)
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  userName ({ profile }) {
    if (profile) {
      const {
        firstName,
        lastName,
        email
      } = profile

      return firstName ? `${firstName} ${lastName}` : email
    }

    return ''
  },

  isAdvisor ({ profile }) {
    return profile
      ? checkAdvisoryRole(profile.roles)
      : false
  },

  isStatisticsOnly ({ profile }) {
    if (profile?.roles) {
      return checkStatisticsOnlyRole(profile.roles)
    } else {
      return false
    }
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
